import { SearchIcon } from '@blocksuite/icons/rc';
import type { FC } from 'react';

import * as styles from './workspace-overview.css';

/** Search field of the workspace overview panels (automations, databases). */
export const WorkspaceOverviewSearch: FC<{
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
}> = ({ value, onChange, placeholder }) => (
  <div className={styles.searchContainer}>
    <span className={styles.searchIcon} aria-hidden="true">
      <SearchIcon />
    </span>
    <input
      type="search"
      className={styles.searchInput}
      placeholder={placeholder}
      aria-label={placeholder}
      value={value}
      onChange={e => onChange(e.target.value)}
    />
  </div>
);
